import S from 's-js';
import * as Surplus from 'surplus';
import { Loading } from './Loading';
export function PaginatedFeed({ size, feed, children, loading = 'Loading...', empty = 'No items.' }) {
    const page = S.value(0), paginatedFeed = S(() => feed(page()));
    return (<Loading task={paginatedFeed} placeholder={loading}>
            {resp => resp.items.length === 0 ? empty :
        resp.items.map(children)
            .concat(<Paginator size={size} total={resp.total} page={page}/>)}
        </Loading>);
}
function Paginator({ size, total, page }) {
    const pages = [...Array(Math.ceil(total / size)).keys()];
    return (<nav>
            <ul class="pagination">
                {pages.length > 1 && pages.map(i => <li class={"page-item " + (i === page() ? "active" : "")} onClick={() => (page(i), false)}>
                        <a class="page-link" href="">{i + 1}</a>
                    </li>)}
            </ul>
        </nav>);
}
